module.exports = __webpack_public_path__ + "img/salesman_index_goodsBtn.5117a4b4.png";